/**
 * What the screen's ONE live region says: the list's own sentence, or a notice about an act, and
 * when the notice steps aside.
 *
 * An act (a save, a delete, a new cover) sets its sentence only once the catalogue has been
 * re-read, so what the list was saying at that moment is already the list's NEW sentence. The
 * notice is heard against that sentence and stands until the list has something else to say — a
 * filter, a search, a scope switch, a change of order. No timer takes it down.
 */

/** A notice from an act. `id` is new per notice, so one sentence twice is two announcements. */
export interface LiveNotice {
  readonly id: number;
  readonly text: string;
}

/** Which notice was heard, and what the list was saying when it was. */
export interface HeardNotice {
  readonly id: number;
  readonly said: string;
}

/** The record to keep after this render: unchanged unless a NEW notice has arrived. */
export function heardNotice(
  notice: LiveNotice | null,
  heard: HeardNotice | null,
  announcement: string,
): HeardNotice | null {
  if (notice === null || heard?.id === notice.id) return heard;
  return { id: notice.id, said: announcement };
}

/** What the region says now. */
export function liveMessage(
  notice: LiveNotice | null,
  heard: HeardNotice | null,
  announcement: string,
): string {
  return notice !== null && heard?.id === notice.id && heard.said === announcement
    ? notice.text
    : announcement;
}
